import { getMerchantInfo, isSiYiMember, isSiYiTeam } from '@util'
// iframe 嵌套页面的路由，不同路由对应不同类目
export const ROUTES = {
  '2': 'planner',
  '12': 'full-dress'
}

export const iframeUrlGenerator = (propertyId, theme, editorMode) => {
  const HASH = new Date().getTime() // 用于给iframe添加时间戳，解决缓存问题
  const merchantId = getMerchantInfo().id
  const business_status = getMerchantInfo().business_status // 北京合作商家状态标识
  // eslint-disable-next-line no-undef
  const basePrefix = `${__HUNLIJI_DOMAIN__}/p/wedding/Public/wap/m/merchant/#/homepage/`
  const baseSuffix = `?id=${merchantId}&theme=${theme}&wapType=${editorMode}&timestamp=${HASH}`
  if (propertyId == '2') {
    return basePrefix + 'planner' + baseSuffix
  }
  if (propertyId == '12') {
    return basePrefix + 'full-dress' + baseSuffix
  }
  if (propertyId == '13') {
    // eslint-disable-next-line no-undef
    return `${_HOTEL_DOMAIN_}/h5/hangzhou/detail_${merchantId}?wapType=${editorMode ||
      1}&theme=${theme}&busStatus=${business_status}`
  }
  if (propertyId == '11') {
    if (isSiYiTeam()) {
      // eslint-disable-next-line no-undef
      return `${__MOBILE_DOMAIN}/homepage/${propertyId}/${merchantId}?theme=${theme}&wapType=${editorMode}`
    }
    if (isSiYiMember()) {
      // eslint-disable-next-line no-undef
      return `${__MOBILE_DOMAIN}/homepage_person/${propertyId}/${merchantId}?theme=${theme}&wapType=${editorMode}`
    }
  }
  if (propertyId == '14') {
    // eslint-disable-next-line no-undef
    return `${__MOBILE_DOMAIN}/homepage/${propertyId}/${merchantId}?theme=${theme}&wapType=${editorMode}`
  }
  return ''
}

export const AREALINK = {
  hotel_cover: '#/localMerchant/coverSetting',
  hotel_info: '#/localMerchant/uniqueInfo',
  hotel_position: '#/localMerchant/editStore',
  hotel_hall: '#/localMerchant/siteManage',
  hotel_menu: '#/localMerchant/menuManage',
  hotel_package: '#/localMerchant/mealManage',
  hotel_active: '#/localMerchant/registrationActivity',
  hotel_comment: '#/localMerchant/appraise',
  hotel_chat: '#/LocalMerchant/SkyEyeSystem',
  hotel_gift: '#/localMerchant/exclusiveOffers'
}
